class AuthenticationError extends Error {
  message: string;

  code: number | string;

  isPasswordRelated: boolean;

  isEmailRelated: boolean;
}

export default AuthenticationError;
